
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'DeleteTeamAccordion',
  data() {
    return {
      chevronIconAnimateClass: ''
    }
  },
  methods: {
    /**
     * Handler for the `isOpen` event emitted by `ZAccordionItem`
     *
     * @param {boolean} open
     * @returns {void}
     */
    isOpenHandler(open: boolean): void {
      this.chevronIconAnimateClass = open
        ? 'animate-first-quarter-spin rotate-90'
        : 'animate-reverse-quarter-spin rotate-0'
    }
  }
})
